module.exports = __webpack_public_path__ + "static/media/10005.e791ced1.jpg";